<template>
    <div class="page" id="goals">
        <header class="pageHeader">
            <fade-image src="assets/headers/goals.png" />
        </header>

        <div id="scroller" class="small">
            <div class="pageHeaderIntro">
                <h1>Goals</h1>
                <img class="icon" src="~@/assets/icons/headers/goals.svg" />
            </div>

            <empty-placeholder
                class="mt10"
                v-if="
                    user.skills.length == 0 &&
                    starredLessons &&
                    starredLessons.length == 0 &&
                    reminders &&
                    reminders.length == 0
                "
            >
                TIP: This area is awaiting updates from your Pro and other areas of your account.
                Check back soon for practice drills, key reminders and your favourite or most
                important lesson records.
            </empty-placeholder>

            <skills-score v-if="user.skills_enabled && user.skills.length > 0" />

            <div class="starredLessons" v-if="starredLessons.length > 0">
                <h2 class="title">Star Lessons:</h2>

                <ul class="lessonList">
                    <li
                        class="historyLesson"
                        v-for="lesson in starredLessons"
                        :key="lesson.id"
                        :class="{ noRecord: !lesson.record }"
                    >
                        <router-link :to="{ name: 'playerLesson', params: { id: lesson.id } }">
                            <span v-if="!lesson.record">
                                {{ $date(lesson.date).format("DD MMM YYYY") }}
                                <strong>Awaiting record update</strong>
                                <img class="recordArrow" src="@/assets/arrow-right-white-2.svg" />
                            </span>
                            <span v-else>
                                <b
                                    ><span v-if="!lesson.title">Untitled record</span
                                    ><span class="title" v-else>{{ lesson.title }}</span></b
                                >
                                {{ $date(lesson.date).format("DD MMM YYYY") }}

                                <template v-if="lesson.start != lesson.end">
                                    {{ $date("2020-12-08 " + lesson.start).format("HH:mm") }} -
                                    {{ $date("2020-12-08 " + lesson.end).format("HH:mm") }}
                                </template>

                                <lesson-star :lesson="lesson" />
                                <img class="recordArrow" src="@/assets/arrow-right-white.svg" />
                            </span>
                        </router-link>

                        <lesson-locked-overlay
                            v-if="isLessonRecordLocked(lesson)"
                            :lesson="lesson"
                        />
                    </li>
                </ul>
            </div>

            <div class="playerRemindersWrapper" v-if="reminders && reminders.length > 0">
                <span class="title">Key Reminders: <img src="@/assets/icons/ribbon.svg" /></span>

                <div id="keyReminders" class="keyReminders2">
                    <ul>
                        <reminder-item
                            v-for="reminder in reminders"
                            :reminder="reminder"
                            :key="reminder.id"
                        />
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import FadeImage from "@/components/App/fade-image";
import ReminderItem from "@/components/Shared/Reminder-item";

import skillsScore from "@/components/Player/Skills-score";
import LessonStar from "@/components/Player/Lessons/lesson-star";
import LessonLockedOverlay from "@/components/Player/Lessons/lesson-locked-overlay";
import lessonRecordAccess from "@/mixins/lesson-record-access";
export default {
    name: "player-goals",
    mixins: [lessonRecordAccess],
    components: {
        EmptyPlaceholder,
        LessonStar,
        FadeImage,
        ReminderItem,
        skillsScore,
        LessonLockedOverlay,
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        starredLessons() {
            return this.$store.state.user.lessons.filter(($item) => {
                return $item.starred == true;
            });
        },
    },
    created() {
        this.getReminders();
        this.$store.dispatch("getUser");
    },
    data() {
        return {
            reminders: false,
        };
    },
    methods: {
        getReminders() {
            window.axios
                .get("/player/" + this.$store.state.user.id + "/reminders")
                .then((response) => {
                    this.reminders = response.data;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#goals {
    #skillScore {
        margin-bottom: 20px;
    }
    .playerRemindersWrapper {
        .title {
            display: block;
            margin-bottom: 10px;
            img {
                float: right;
            }
        }
        .keyReminders2 {
            padding-top: 0px;
            padding-bottom: 0px;
        }
        .info {
            padding-left: 0px;
            background: transparent;
            line-height: 23px;
            margin-bottom: 0px;
        }
    }
    .starredLessons {
        margin-bottom: 30px;
    }
    .historyLesson {
        background: #eef5f2;
        border-radius: $radius;
        margin-bottom: 10px;
        padding: 17px 20px;
        position: relative;

        a {
            font-weight: 200;
            text-decoration: none;
            color: $green_0;
        }
        &.noRecord {
            background: $green_0;
            color: white;
            a {
                color: white;
            }
            strong {
                font-weight: 400;
                display: block;
                margin-top: 10px;
            }
        }
        b {
            font-weight: 400;
            margin-bottom: 10px;
            display: block;
        }
        .recordArrow {
            position: absolute;
            right: 15px;
            bottom: 20px;
            pointer-events: none;
        }
        .star {
            position: absolute;
            right: 35px;
            bottom: 14px;
            top: auto;
        }
    }
    .keyReminders2 {
        padding-left: 20px !important;
        padding-right: 20px !important;
    }
}
</style>
